import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateUserForm from "../../forms/CreateOrUpdateUserForm";
import { UserResponseDto } from "../../shared/dtos/user/UserResponseDto";
import { UserSummaryDto } from "../../shared/dtos/user/UserSummaryDto";

interface UpdateUserModalProps {
  open: boolean;
  onClose: () => void;
  user: UserSummaryDto | UserResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateUserModal: React.FC<UpdateUserModalProps> = ({
  open,
  onClose,
  user,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit User: ${user.firstName}`}
      width="md"
      loading={loading}
    >
      <CreateOrUpdateUserForm
        isEditing={true}
        user={user}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};
export default UpdateUserModal;
